import ModalAddReviewFormPresenter from "../components/modal-add-review-form/presenter/modal-add-review-form.js";

const triggerElement = document.querySelector(`.button_add-review`);

if (triggerElement) {
  const modalAddReviewFormComponent = new ModalAddReviewFormPresenter(triggerElement);
  modalAddReviewFormComponent.init();
}
